import { Chip } from '@mui/material';
import { tryParseMediaProcessingResult } from '../../types/multimodal';

export interface MediaProcessingStatusProps {
  processedContentJson?: string | null;
}

/**
 * Displays a compact processing status for a media attachment.
 */
export const MediaProcessingStatus = ({ processedContentJson }: MediaProcessingStatusProps) => {
  const result = tryParseMediaProcessingResult(processedContentJson);
  if (!result) return null;

  const status = result.status ?? 'Completed';
  const color =
    status === 'Completed'
      ? 'success'
      : status === 'Failed'
        ? 'error'
        : status === 'Processing'
          ? 'warning'
          : status === 'Skipped'
            ? 'default'
            : 'default';

  return <Chip label={status} size="small" color={color as any} variant="outlined" />;
};

